import type { Requests } from "../common/request.common";
import type { SkipAuditSubscriptionResponseTypes } from "../common/response.common";
import { post, postEmpty } from "./common";

export const skipAuditSubscription = {
    record(data: typeof Requests.SkipAuditSubscription.Record.Input) {
        return post<typeof data, SkipAuditSubscriptionResponseTypes.Record>(
            `/skip-audit-subscription/record`,
            data,
        );
    },
    toggle(id: string) {
        return postEmpty<SkipAuditSubscriptionResponseTypes.Toggle>(
            `/skip-audit-subscription/toggle/${id}`,
        );
    },
};
